import { TooltipFormatter } from '@/shared/ui/components';
import { t } from 'ttag';
import { useInfoECGSelection } from './useInfoECGSelection';
import { symptomsFormatter } from '../../../../lib/infoECGSelection';
import type { InfoECGSelectionProps } from './infoECGSelection.types';

/**
 * Renders the symptoms and technician comments of a selected event's ECG. Formats the symptom list through symptomsFormatter and clamps the comments inside a tooltip formatter using the row count from useInfoECGSelection.
 *
 * @param data - Event data supplying symptoms and technician comments.
 * @param eventId - Identifier of the event, used to measure available comment rows.
 * @returns The event symptoms and comments block.
 */
const InfoECGSelection = ({ data, eventId }: InfoECGSelectionProps) => {
  const { commentRows } = useInfoECGSelection({ eventId });

  return (
    <div className="info-ecg w-100 flex-row__is">
      <div className="info-ecg__group-comment flex-col__is">
        <span className="b">{`${t`Symptoms`}:`}</span>
        <div className="symptoms">{symptomsFormatter(data?.symptoms)}</div>
      </div>
      <div className="info-ecg__group-comment flex-col__is">
        <span className="b">{`${t`Technician comments`}:`}</span>
        <div className="comments">
          <TooltipFormatter text={data?.comments} rows={commentRows} />
        </div>
      </div>
    </div>
  );
};

export default InfoECGSelection;
